// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

export interface MasterAccountsCollectionModel {
    accounts: AccountModel[];
}
export interface MasterAccountsParameter extends ApiParameter {
    filter?: string;
    size?: number;
    currentPage?: number;
}

const MasterAccountsUrl = "api/ces/masterAccounts";

export async function getMasterAccounts(parameter: MasterAccountsParameter): Promise<MasterAccountsCollectionModel> {
    const accounts = await get<MasterAccountsCollectionModel>(MasterAccountsUrl, parameter);
    return accounts;
}
